const first = [
  // {
  //   id: '221',
  //   label: "测试",
  //   href: '',
  //   icon: '',
  //   meta: {},
  //   children: [
  //     {
  //       id: '1',
  //       label: "领事认证管理",
  //       href: '/components/foreign_consular_management',
  //       icon: '',
  //       children: [],
  //       meta: {}
  //     },
  //   ]
  // },
]

export const menu = first;
